import type { PartDefinition } from "@rogue/rackbuilder"
import { WallMountOptions } from "../../RackTypes"
import { WallmountBuilder } from "./wallmountBuilder"
import { RML390Full } from "./variants/390Full"
import { RML90Slim } from "./variants/90SlimRack"

export class WallmountFactory {
  static build(config: WallMountOptions): PartDefinition {
    if (config.is390Full) {
      return new RML390Full(config).build()
    }
    
    if (config.is90SlimRack) {
      return new RML90Slim(config).build()
    }
    
    // RML-3WC, RML-3W, RM-3W variants use base class directly
    return new WallmountBuilder(config).build()
  }
}
